import { useState } from "react";
import { Box, Chip, TextField } from "@mui/material";
import { tokens } from "../theme";

// Chip-input for candidate labels: type + Enter/comma to add, Backspace to remove
// the last. Mirrors AI Factory core's classifier playground label input.
export default function LabelChips({ labels, onChange, disabled, placeholder = "Add a label, press Enter" }) {
  const [draft, setDraft] = useState("");

  const add = (raw) => {
    // Split on commas/newlines so a pasted or comma-separated list becomes chips.
    const parts = (raw || "").split(/[,\n]+/).map((s) => s.trim()).filter(Boolean);
    if (parts.length) {
      const next = [...labels];
      for (const t of parts) if (!next.includes(t)) next.push(t);
      onChange(next);
    }
    setDraft("");
  };
  const onKey = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      add(draft);
    } else if (e.key === "Backspace" && !draft && labels.length) {
      onChange(labels.slice(0, -1));
    }
  };
  const onPaste = (e) => {
    const text = e.clipboardData.getData("text");
    if (text && /[,\n]/.test(text)) {
      e.preventDefault();
      add(draft + text);
    }
  };

  return (
    <Box
      sx={{
        display: "flex", flexWrap: "wrap", gap: 0.75, alignItems: "center",
        border: "1px solid", borderColor: tokens.line, borderRadius: 2, p: 1, minHeight: 46,
        background: disabled ? "#f7fafd" : "#fff",
      }}
    >
      {labels.map((l) => (
        <Chip
          key={l}
          label={l}
          size="small"
          onDelete={disabled ? undefined : () => onChange(labels.filter((x) => x !== l))}
        />
      ))}
      <TextField
        variant="standard"
        value={draft}
        disabled={disabled}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={onKey}
        onPaste={onPaste}
        onBlur={() => add(draft)}
        placeholder={labels.length ? "" : placeholder}
        InputProps={{ disableUnderline: true }}
        sx={{ flex: 1, minWidth: 130 }}
      />
    </Box>
  );
}
